<template>
  <div>
    <b-row
      v-if="!hideTitle"
      class="mt-2"
    >
      <b-col lg="12">
        <titleSection
          title="Información de dependencia"
          subtitle=""
          icon="MapPinIcon"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        cols="12"
        :lg="horizontal ? 4 : 12"
        :md="horizontal ? 4 : 12"
        sm="12"
        class="m-0"
      >
        <selecttg
          :tg.sync="idtg"
          @tipogob="idtg=$event"
          @catalogotiposgob="cdtg=$event"
        />
      </b-col>
      <b-col
        v-if="availableComponentActiveSelectEstados"
        cols="12"
        :lg="horizontal ? 4 : 12"
        :md="horizontal ? 4 : 12"
        sm="12"
        class="m-0"
      >
        <component
          :is="availableComponentActiveSelectEstados"
          ref="tipogobierno"
          :ef.sync="idef"
          @selectef="idef=$event"
        />
      </b-col>
      <b-col
        v-if="availableComponentActiveSelectMuni"
        cols="12"
        :lg="horizontal ? 4 : 12"
        :md="horizontal ? 4 : 12"
        sm="12"
        class="m-0"
      >
        <component
          :is="availableComponentActiveSelectMuni"
          ref="refmunicipios"
          :ef.sync="idef"
          :muni.sync="idmuni"
          @select="idmuni=$event"
          @selectmuni="idmuni=$event"
        />
      </b-col>
      <b-col
        v-if="availableComponentActiveSelectDep"
        cols="12"
        :lg="horizontal ? 4 : 12"
        :md="horizontal ? 4 : 12"
        sm="12"
        class="m-0"
      >
        <component
          :is="availableComponentActiveSelectDep"
          :ef.sync="idef"
          :dp.sync="iddp"
          :tipo.sync="idtg"
          @selectdp="iddp=$event"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import selecttg from '@/views/components/selects/select-tipo-gob.vue'
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'
import { ref, watch, onMounted } from '@vue/composition-api'

const selectestados = () => import('@/views/components/selects/select-estados.vue')
const selectmunicipios = () => import('@/views/components/selects/select-municipio.vue')
const selectdependencia = () => import('@/views/components/selects/select-dependencia.vue')

export default {
  components: {
    BRow,
    BCol,
    selecttg,
    titleSection,
    selectestados,
    selectmunicipios,
    selectdependencia,
  },
  props: {
    resetea: {
      type: [Boolean, null],
      default: null,
    },
    inicializadatos: {
      type: [Object, null],
      default: null,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const cdtg = null
    const idtg = ref(null)
    const idef = ref(null)
    const idmuni = ref(null)
    const iddp = ref(null)
    const inicializar = ref(false)
    const availableComponentActiveSelectEstados = ref(null)
    const availableComponentActiveSelectMuni = ref(null)
    const availableComponentActiveSelectDep = ref(null)
    const updateemit = () => {
      emit('tipodegobierno', idtg.value)
      emit('idestado', idef.value)
      emit('idmunicipio', idmuni.value)
      emit('iddependencia', iddp.value)
    }
    const inicializarfun = valor => new Promise(resolve => {
      if (valor.tipogob) {
        idtg.value = { id: valor.tipogob.id, nombre: valor.tipogob.nombre }
        if (valor.nivel2 && valor.nivel2 !== null) {
          const nivel2 = { id: valor.nivel2.id, nombre: valor.nivel2.nombre }
          // federal
          if (valor.tipogob.id === 1) {
            iddp.value = nivel2
            updateemit()
            resolve()
          }
          // estatal
          if (valor.nivel3 && valor.nivel3 !== null) {
            const nivel3 = { id: valor.nivel3.id, nombre: valor.nivel3.nombre }
            if (valor.tipogob.id === 2) {
              idef.value = nivel2
              iddp.value = nivel3
              updateemit()
              resolve()
            }
            // municipal
            if (valor.tipogob.id === 3) {
              idef.value = nivel2
              idmuni.value = nivel3
              updateemit()
              resolve()
            }
          }
        }
      }
    })
    const configinicializa = () => {
      if (props.inicializadatos !== null) {
        inicializar.value = true
        const resini = inicializarfun(props.inicializadatos)
        resini.then(() => {
          inicializar.value = false
          // eslint-disable-next-line no-unused-vars
        }, () => { inicializar.value = false })
      }
    }
    watch(() => idtg.value, valor => {
      if (valor !== null) {
        availableComponentActiveSelectEstados.value = valor.id === 2 || valor.id === 3 ? 'selectestados' : null
        availableComponentActiveSelectMuni.value = valor.id === 3 ? 'selectmunicipios' : null
        availableComponentActiveSelectDep.value = valor.id === 1 || valor.id === 2 ? 'selectdependencia' : null
      }
      if (inicializar.value === false) {
        idef.value = null
        idmuni.value = null
        iddp.value = null
        updateemit()
      }
    })
    watch(() => idef.value, () => {
      if (inicializar.value === false) {
        idmuni.value = null
        iddp.value = null
        updateemit()
      }
    })
    watch(() => idmuni.value, () => {
      if (inicializar.value === false) {
        iddp.value = null
        updateemit()
      }
    })
    watch(() => iddp.value, () => {
      if (inicializar.value === false) { updateemit() }
    })
    watch(() => props.resetea, valor => {
      if (valor === true) {
        idtg.value = null
        idef.value = null
        idmuni.value = null
        iddp.value = null
        emit('reseteaemit', false)
      }
    })
    watch(() => props.inicializadatos, () => {
      configinicializa()
    })
    onMounted(() => {
      configinicializa()
    })

    return {
      cdtg,
      idtg,
      idef,
      idmuni,
      iddp,
      inicializar,
      availableComponentActiveSelectEstados,
      availableComponentActiveSelectMuni,
      availableComponentActiveSelectDep,
      inicializarfun,
      updateemit,
      configinicializa,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
